<cm-display-html class="details-description text-justify" [content]="contentDetails.stepDescription"></cm-display-html>
<cm-step-on-behalf-list
    *ngIf="contentDetails.onBehalfIndicator"
    class="info-section"
    [onBehalfIndicator]="contentDetails.onBehalfIndicator"
></cm-step-on-behalf-list>
<cm-display-html
    *ngIf="contentDetails.disclosureText"
    class="form-hint text-justify"
    [content]="contentDetails.disclosureText"
></cm-display-html>
